import { useTranslation } from "react-i18next";
import cookies from "js-cookie";

import {
  Container,
  Item,
  Card,
  Btn,
  Icon,
  DetailItem,
  Title,
  Permissions,
  Count,
  BtnAdd,
  IconBtnAdd,
} from "./Element";
import card from "../../Images/cards/role.svg";
import card_ltr from "../../Images/cards/role_ltr.svg";
import setting from "../../Images/setting.svg";
import icon from "../../Images/addIcon.svg";
import { useEffect, useState } from "react";

const List = ({ data, handleOpenModal }) => {
  const [items, setItems] = useState([]);
  const currentLanguageCode = cookies.get("i18next");
  const { t } = useTranslation();

  useEffect(() => {
    if (data) {
      setItems(data);
    }
  }, [data]);

  return (
    <>
      <Container>
        {items.map((item) => (
          <Item key={item.id}>
            <Card src={currentLanguageCode === "fa" ? card : card_ltr} />
            <DetailItem>
              <Title>
                {currentLanguageCode === "fa" ? item.persian_title : item.title}
              </Title>
              <Permissions>
                <Count>{item.permissions.length}</Count>
                {t("permissions")}
              </Permissions>
            </DetailItem>
            <Btn onClick={() => handleOpenModal("modalOperations", item)}>
              <Icon src={setting} />
            </Btn>
          </Item>
        ))}
        <BtnAdd onClick={() => handleOpenModal("addModal")}>
          <IconBtnAdd src={icon} />
          {t("add role")}
        </BtnAdd>
      </Container>
    </>
  );
};

export default List;
